var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags)?_c('div',[_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index,staticClass:"chips",on:{"click":function($event){return _vm.doSearch(tag)}}},[_vm._v(_vm._s(tag))])}),_c('error-message',{ref:"errorDialog"})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }